// extracted by mini-css-extract-plugin
export default {"mainCon":"mainCon--i8VvY","markerAnimationScale":"markerAnimationScale--la3_Q"};